<mat-toolbar class="subtitulo">Matrícula do beneficiário na atividade</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">

        <div *ngIf="area != null && area !== 'S'" fxLayout="row" fxLayoutGap="50px" fxFlexFill fxLayoutAlign="center center">

            <div style="border-style: solid; border-color: coral;">
                <span style="color: blue">
                    Onde deseja realizar a matrícula ?
                </span>
                <mat-radio-group [(ngModel)]="tipoOficina" 
                                 name="tipoOficina" 
                                 (change)="carregarOficinas()">
                    <mat-radio-button value="T" style="padding-left: 30px;">Turma</mat-radio-button>
                    <mat-radio-button value="O" style="padding-left: 30px;">Atividade</mat-radio-button>
                </mat-radio-group>
            </div>

        </div>

        <br />
        <div *ngIf="tipoOficina">
            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                <!-- TURMAS -->
                <div fxLayout="column" fxFlex="45%" *ngIf="isTurma()">
                    <mat-toolbar class="titulopartes">Turma</mat-toolbar>
                    <mat-form-field style="margin: 0 20px 20px 20px">
                        <mat-select [(ngModel)]="atividadeAluno.atividade.idTurma" name="turma"
                            (selectionChange)="carregarOficinas()" required>
                            <mat-option></mat-option>
                            <mat-option *ngFor="let i of turmas" [value]="i.id">
                                {{i.descricao}}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="turmas?.length === 0" align="start">Nenhuma turma cadastrada</mat-hint>
                    </mat-form-field>
                </div>

                <!-- BENEFICIARIO-->
                <div fxLayout="column" fxFlex="45%">
                    <mat-toolbar class="titulopartes">Beneficiário</mat-toolbar>
                    <div ngModelGroup="comboBeneficiario" fxFlex="100" fxLayoutGap="20px" style="padding-top: 15px;">
                        <combo-beneficiario [showDisplayId]="false" 
                                            [obrigatorio]="true" 
                                            [selecionado]="filtro.aluno"
                                            (valorChange)="onValorChange($event)">
                        </combo-beneficiario>
                    </div>
                </div>

                <!-- ATIVIDADE-->
                <div fxLayout="column" fxFlex="45%">
                    <mat-toolbar class="titulopartes">Data</mat-toolbar>
                    <mat-form-field style="margin: 0 0 0 20px" fxFlex="15%">
                        <input style="margin-left: 20px" matInput name="dataInicioAtividade_{{pinData}}"
                            [matDatepicker]="dataInicioAtividade" placeholder="Data Início:"
                            [(ngModel)]="atividadeAluno.dataInicioAtividade" required (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataInicioAtividade"></mat-datepicker-toggle>
                        <mat-datepicker #dataInicioAtividade></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>

            <mat-toolbar class="titulopartes">Atividade</mat-toolbar>
            <div fxLayout="row">
                <mat-form-field fxFlex="95%" style="margin: 0 20px 20px 20px">
                        <mat-select [(ngModel)]="atividadeAluno.atividade.id" name="atividade"
                            (selectionChange)="mostrarDadosAtividade($event.value)" required>
                            <mat-option></mat-option>
                            <mat-option *ngFor="let i of atividades" [value]="i.id">
                                {{i.descricao}}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="atividades?.length === 0" align="start">Nenhuma atividade cadastrada</mat-hint>
                    </mat-form-field>

            </div>


            <!-- OUTRAS INFORMACOES-->
            <mat-toolbar class="titulopartes">Outras Informações</mat-toolbar>
            <div fxLayout="row">
              
                <mat-form-field style="margin: 0 0 0 20px" fxFlex="15%">
                    <input style="margin-left: 20px" 
                           matInput name="dataDesvinculacao"
                           [min]="atividadeAluno.dataInicioAtividade"
                           [matDatepicker]="dataDesvinculacao" placeholder="Data de desvinculação"
                           [(ngModel)]="atividadeAluno.dataDesvinculacao">
                    <mat-datepicker-toggle matSuffix [for]="dataDesvinculacao"></mat-datepicker-toggle>
                    <mat-datepicker #dataDesvinculacao></mat-datepicker>
                </mat-form-field>

                <mat-form-field style="margin-left: 20px" fxFlex="80%" appearance="outline">
                    <mat-label>Descrição:</mat-label>
                    <textarea matInput #message name="descricao"  cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" [(ngModel)]="atividadeAluno.descDesligamento" maxlength="200">
                         </textarea>
                    <mat-hint align="end">{{message.value.length}} / 200</mat-hint>
                </mat-form-field>

            </div>

            <div *ngIf="atividadeAluno.aluno.id">
                <dados-aluno [aluno]="atividadeAluno.aluno"></dados-aluno>
            </div>

            <div *ngIf="atividadeAluno.atividade.id">
                <dados-atividade [atividade]=atividadeAluno.atividade></dados-atividade>
            </div>

            
            <div *ngIf="conflitos && conflitos.length > 0" style="padding-top: 25px;">
                <mat-toolbar class="titulopartes" style="background-color: #fbad76;color: black;">
                    Conflitos de matrículas
                </mat-toolbar>
    
                <mat-list *ngFor="let reg of conflitos">
                    <div mat-subheader style="font-size: 16px;font-weight: 300;color: red;" fxLayout="row" >
                        {{reg.oficina.atividade.descricao}} - Período: {{getPeriodoConflito(reg.oficina)}} - Horário: {{reg.oficina.atividade.horaInicio}} às {{reg.oficina.atividade.horaFim}} - Dia(s): {{getDadosConflito(reg.oficina)}}
                    </div>
                    <mat-list-item style="padding-left: 30px;" *ngFor="let conf of reg.conflitos">                  
                      <div mat-line>{{conf.atividade.descricao}} - Período: {{getPeriodoConflito(conf)}} - Horário: {{conf.atividade.horaInicio}} às {{conf.atividade.horaFim}}</div>
                      <div mat-line>Dia(s): {{getDadosConflito(conf)}}</div>                  
                    </mat-list-item>
                    <mat-divider></mat-divider>
                </mat-list>
            </div>


            <!-- BOTOES -->
            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                fxFlexFill>
                <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar"
                    fxFlex="20%" color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
                </button>

                <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar"
                    fxFlex="20%" color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                    Atualizar
                </button>

                <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                    Limpar
                </button>
                <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                    Cancelar
                </button>

            </div>

        </div>


    </form>

</div>